import { NUMBER_FONT, NAME_FONT } from './fonts';

// Numbers and names are the same kind of item; these configs hold the differences.

export const NUMBER_CONFIG = {
    noun: 'number',
    plural: 'Numbers',
    addLabel: 'Number',
    cardTitle: 'Jersey Number',
    hint: 'Add up to 3 numbers (1–2 digits).',
    max: 3,
    valueKey: 'value',
    initialValue: '00',
    placeholder: '0',
    inputLabel: 'Number (1–2 digits)',
    inputPlaceholder: '',
    inputMode: 'numeric',
    maxLength: 2,
    sanitize: (v) => v.replace(/[^0-9]/g, '').slice(0, 2),
    font: NUMBER_FONT,
    fontWeight: 900,
    previewSize: '18px',
    previewStroke: 3,
    inputSize: '22px',
    outlineWidth: 28,
    x: 480,
    y: 700,
    // Preview rendering (artboard units)
    baseFontSize: 300,
    letterSpacing: 8,
};

export const NAME_CONFIG = {
    noun: 'name',
    plural: 'Names',
    addLabel: 'Name',
    cardTitle: 'Name / Word',
    hint: 'Add up to 3 names or words.',
    max: 3,
    valueKey: 'text',
    initialValue: '',
    placeholder: 'NAME',
    inputLabel: 'Text',
    inputPlaceholder: 'Enter name or word',
    inputMode: 'text',
    maxLength: 20,
    sanitize: (v) => v,
    font: NAME_FONT,
    fontWeight: 400,
    previewSize: '14px',
    previewStroke: 2,
    inputSize: '18px',
    outlineWidth: 20,
    x: 825,
    y: 900,
    baseFontSize: 180,
    letterSpacing: 0,
};
